import React from 'react';
import '../ui.css';

const KpiCard = ({ titulo, valor, detalle, accion, onAccion }) => {
    return (
        <div className="card border-0 shadow-sm ui-kpi">
            <div className="ui-kpi-titulo">{titulo}</div>
            <div className="ui-kpi-valor">{valor}</div>
            <div className="ui-kpi-detalle">
                {detalle}
                {accion && (
                    <>
                        {' · '}
                        <span
                            className="ui-kpi-accion"
                            role={onAccion ? 'button' : undefined}
                            onClick={onAccion}
                        >
                            {accion}
                        </span>
                    </>
                )}
            </div>
        </div>
    );
};

export default KpiCard;
